import React from 'react';

const CountryContext = React.createContext<any>({
  currentCountry: 'EAUE',
  setCurrentCountry: () => {},
});

export default CountryContext;
